/**
 * DigitalAssetWeek: unlisted `/events/digital-asset-week` route (QR only).
 * Body is the hand-built design from `digital-asset-week.html`, which
 * carries its own header, so no site Navbar; site Footer follows it.
 */
import { Helmet } from "react-helmet-async";
import { DigitalAssetWeekHost } from "../components/DigitalAssetWeekHost";
import { Footer } from "../components/Footer";

export default function DigitalAssetWeek() {
  return (
    <main className="min-h-screen" data-testid="daw-page">
      <Helmet>
        <title>Five questions from Digital Asset Week, T-REX</title>
        <meta name="description" content="Five questions about tokenisation that came up all week in London, answered properly: cost, chain choice, privacy, liquidity and repeated KYC." />
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Five questions, answered properly" />
        <meta property="og:description" content="Cost, chain choice, privacy, liquidity and repeated KYC." />
        <meta property="og:type" content="article" />
      </Helmet>
      <DigitalAssetWeekHost />
      <Footer />
    </main>
  );
}
